import React, { useContext, useState } from "react";
import Context from "../../../Context";
import FavModal from "../../Misc/FavModal";
function HeaderFavButton() {
  const cx = useContext(Context);
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="topbar-item">
        <div
          onClick={() => setOpen(true)}
          className={`btn btn-icon btn-clean btn-lg mr-1`}
        >
          <i className="fa fa-star-o text-primary"></i>
        </div>
      </div>
      {open && <FavModal context={cx} onHide={() => setOpen(false)} />}
    </>
  );
}
export default HeaderFavButton;
